import { Icon, IconName } from '@unmind/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import RoutePath from 'App/RoutePath';
import { useMatches } from 'Book/shared/hooks';

import img from './assets/match.png';
import { Link } from './styles';

export default () => {
  const { t } = useTranslation('book', { keyPrefix: 'therapyAndCoaching' });
  const { practitionerMatchesLoading, userHasPractitionerMatches } =
    useMatches();

  if (practitionerMatchesLoading || userHasPractitionerMatches) {
    return null;
  }

  return (
    <Link to={RoutePath.BookMatch} className="find-match-button">
      <img src={img} alt="" />
      {t('findMatch')}
      <Icon iconName={IconName.Arrow} />
    </Link>
  );
};
